import { render, staticRenderFns } from "./boreholeHot.vue?vue&type=template&id=0ae42778&"
import script from "./boreholeHot.vue?vue&type=script&lang=ts&"
export * from "./boreholeHot.vue?vue&type=script&lang=ts&"
import style0 from "./boreholeHot.vue?vue&type=style&index=0&id=0ae42778&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports